import CommonMapper from '@/modules/core/mappers/CommonMapper'
import type LifeRaterAnswers from '@/modules/life/rater/models/APP/LifeRaterAnswers'
import LifeRaterPriceRequest from '@/modules/life/common/models/MID/requests/LifeRaterPriceRequest'
import type LifeHiringInsured from '@/modules/life/hiring/models/APP/LifeHiringInsured'
import type LifeHiringAnswers from '@/modules/life/hiring/models/APP/LifeHiringAnswers'
export default class GetPricingMapper {
  static toRequest(
    data: LifeRaterAnswers | LifeHiringAnswers,
    isQuote: boolean = false,
    mediator?: string
  ): LifeRaterPriceRequest {
    const clientProduct = []
    if (data?.product) {
      clientProduct.push({
        clientCode: data?.product.clientCode,
        productCode: data?.product.productCode
      })
    }

    return new LifeRaterPriceRequest({
      quotationId: data.quotationId ?? undefined,
      quotationNumber: data.product?.quotationNumber || undefined,
      businessLine: data?.businessLine ?? 'AS00',
      insuranceType: data?.insuranceType,
      insuranceStartDate: CommonMapper.toMiddlewareDate(data.startDate),
      revaluationType: data.reevaluationType?.code,
      revaluationValue: data.reevaluationType?.value,
      insureds: this.#mountInsureds(data.insureds as LifeHiringInsured[]),
      clientProduct: clientProduct.length ? clientProduct : null,
      isQuote,
      mediator
    })
  }

  static #mountInsureds(insureds: LifeHiringInsured[]) {
    return insureds.map((i, order) => {
      const showProfessionAndACtivity = !!i.profession
      return {
        birthDate: CommonMapper.toMiddlewareDate(i.userDetails.birthDate),
        riskNumber: String(order + 1),
        profession: showProfessionAndACtivity ? i.profession : undefined,
        activity: showProfessionAndACtivity ? i.activity : undefined,
        coverages: i.additionalCoverages
          .filter((c) => c.checked)
          .map((c) => ({
            coverageCode: c.key,
            sumInsured: c.value
          }))
      }
    })
  }
}
